module.exports = "<md-content>\r\n    <md-nav-bar md-selected-nav-item=\"$ctrl.selectedTab\" nav-bar-aria-label=\"{{'ui.contextualtabs' | translate}}\">\r\n        <md-nav-item ng-repeat=\"tab in $ctrl.tabs track by tab.state\" md-nav-sref=\"{{tab.state}}\" name=\"{{tab.state}}\">\r\n            {{tab.title | translate}}\r\n        </md-nav-item>\r\n        <span flex></span>\r\n        <gmao-user></gmao-user>\r\n    </md-nav-bar>\r\n</md-content>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/front/scripts/module/util/component/gmao-contextual-tabs.html
// module id = 288
// module chunks = 1